const e = "scalar-app", a = "headlessui-portal-root", c = (s) => s !== null && s instanceof HTMLElement, o = (s) => {
  !s || s.classList.contains(e) || s.classList.add(e);
}, d = () => {
  o(document.getElementById(a));
  const s = new MutationObserver(
    (r) => r.forEach(
      ({ addedNodes: n }) => n.forEach((t) => {
        c(t) && t.id === a && o(t);
      })
    )
  );
  return s.observe(document.body, { childList: !0 }), s;
};
export {
  d as addScalarClassesToHeadless
};
